export const Users =
  // 20220425133546
  // https://aggie-api-apps.herokuapp.com/studentsInfo

[
  {
    "id": 0,
    "name": "Addison Shaver",
    "email": "awshaver@aggies.ncat.edu",
    "courses": [
      "Comp165",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.68
  },
  {
    "id": 1,
    "name": "Teon Smith",
    "email": "teonsmith@aggies.ncat.edu",
    "courses": [
      "ENGL101",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.28
  },
  {
    "id": 2,
    "name": "Vikki Britt",
    "email": "VikkiBritt@aggies.ncat.edu",
    "courses": [
      "Math341",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.22
  },
  {
    "id": 3,
    "name": "Katherine Leach",
    "email": "KatherineLeach@aggies.ncat.edu",
    "courses": [
      "Comp280",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.33
  },
  {
    "id": 4,
    "name": "Alisa Portillo",
    "email": "AlisaPortillo@aggies.ncat.edu",
    "courses": [
      "Comp375",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.87
  },
  {
    "id": 5,
    "name": "Jay Stanton",
    "email": "JayStanton@aggies.ncat.edu",
    "courses": [
      "ENGL331",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.9
  },
  {
    "id": 6,
    "name": "Adam O'Brien",
    "email": "AdamBrien@aggies.ncat.edu",
    "courses": [
      "Comp322",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 4
  },
  {
    "id": 7,
    "name": "Tyrique Beach",
    "email": "TyriqueBeach@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.66
  },
  {
    "id": 8,
    "name": "Abu Haines",
    "email": "AbuHaines@aggies.ncat.edu",
    "courses": [
      "Comp300",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.28
  },
  {
    "id": 9,
    "name": "Kasim Chang",
    "email": "KasimChang@aggies.ncat.edu",
    "courses": [
      "Comp496",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.18
  },
  {
    "id": 10,
    "name": "Casper Connelly",
    "email": "CasperConnelly@aggies.ncat.edu",
    "courses": [
      "Comp410",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.12
  },
  {
    "id": 11,
    "name": "Kye Huber",
    "email": "KyeHuber@aggies.ncat.edu",
    "courses": [
      "Comp360",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.63
  },
  {
    "id": 12,
    "name": "Ellouise Vance",
    "email": "EllouiseVance@aggies.ncat.edu",
    "courses": [
      "SPCH250",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.28
  },
  {
    "id": 13,
    "name": "Uzma Logan",
    "email": "UzmaLogan@aggies.ncat.edu",
    "courses": [
      "Comp180",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.77
  },
  {
    "id": 14,
    "name": "Jaxon Watt",
    "email": "JaxonWatt@aggies.ncat.edu",
    "courses": [
      "Comp121",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.58
  },
  {
    "id": 15,
    "name": "Aayush Wilkins",
    "email": "AayushWilkins@aggies.ncat.edu",
    "courses": [
      "Comp167",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.98
  },
  {
    "id": 16,
    "name": "Quinn Stubbs",
    "email": "QuinnStubbs@aggies.ncat.edu",
    "courses": [
      "BIO101",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.28
  },
  {
    "id": 17,
    "name": "Deen Burns",
    "email": "DeenBurns@aggies.ncat.edu",
    "courses": [
      "Comp200",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.32
  },
  {
    "id": 18,
    "name": "Juniper Buckner",
    "email": "JuniperBuckner@aggies.ncat.edu",
    "courses": [
      "Comp385",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.36
  },
  {
    "id": 19,
    "name": "Poppy-Rose Maddox",
    "email": "PRMaddox@aggies.ncat.edu",
    "courses": [
      "Math132",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.6
  },
  {
    "id": 20,
    "name": "Alissa Cochran",
    "email": "AlissaCochran@aggies.ncat.edu",
    "courses": [
      "SPCH251",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.55
  },
  {
    "id": 21,
    "name": "Luella Levy",
    "email": "LuellaLevy@aggies.ncat.edu",
    "courses": [
      "Comp163",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.68
  },
  {
    "id": 22,
    "name": "Kacper Walters",
    "email": "KacperWalters@aggies.ncat.edu",
    "courses": [
      "Comp440",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.18
  },
  {
    "id": 23,
    "name": "Edna Velasquez",
    "email": "EdnaVelasquez@aggies.ncat.edu",
    "courses": [
      "Comp375",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.63
  },
  {
    "id": 24,
    "name": "Alison Tillman",
    "email": "AlisonTillman@aggies.ncat.edu",
    "courses": [
      "ENGL101",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.28
  },
  {
    "id": 25,
    "name": "Fox Hail",
    "email": "FoxHail@aggies.ncat.edu",
    "courses": [
      "Comp163",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.88
  },
  {
    "id": 26,
    "name": "Kayson Reeves",
    "email": "KaysonReeves@aggies.ncat.edu",
    "courses": [
      "Comp165",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.98
  },
  {
    "id": 27,
    "name": "Micheal Robinson",
    "email": "MichealRobinson@aggies.ncat.edu",
    "courses": [
      "Comp410",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.23
  },
  {
    "id": 28,
    "name": "Shannan Whelan",
    "email": "ShannanWhelan@aggies.ncat.edu",
    "courses": [
      "Comp180",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.11
  },
  {
    "id": 29,
    "name": "Lacie-Mae Hayden",
    "email": "LMHayden@aggies.ncat.edu",
    "courses": [
      "Math131",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.34
  },
  {
    "id": 30,
    "name": "Lucie Ahmad",
    "email": "LucieAhmad@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.88
  },
  {
    "id": 31,
    "name": "Akin Mason-Hogans",
    "email": "admasonhogans@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 32,
    "name": "Brett Nunez",
    "email": "BrettNunez@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.88
  },
  {
    "id": 33,
    "name": "Blaze Carroll",
    "email": "BlazeCarroll@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.98
  },
  {
    "id": 34,
    "name": "Alijah Howard",
    "email": "AlijahHoward@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.38
  },
  {
    "id": 35,
    "name": "Elaina Walter",
    "email": "ElainaWalter@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.68
  },
  {
    "id": 36,
    "name": "Makena Stone",
    "email": "MakenaStone@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 37,
    "name": "Tanya Herman",
    "email": "TanyaHerman@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 1.38
  },
  {
    "id": 38,
    "name": "Barbara Mcintyre",
    "email": "BarbaraMcintyre@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.39
  },
  {
    "id": 39,
    "name": "Kaden Alexander",
    "email": "KadenAlexander@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.78
  },
  {
    "id": 40,
    "name": "Yesenia Ballard",
    "email": "YeseniaBallard@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.78
  },
  {
    "id": 41,
    "name": "Cody Davidson",
    "email": "CodyDavidson@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.88
  },
  {
    "id": 42,
    "name": "Bryant Shah",
    "email": "BryantShah@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 43,
    "name": "Madalyn King",
    "email": "MadalynKing@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.28
  },
  {
    "id": 44,
    "name": "Muhammad Mcconnell",
    "email": "MuhammadMcconnell@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.58
  },
  {
    "id": 45,
    "name": "Dimitri Law",
    "email": "dalaw@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.21
  },
  {
    "id": 46,
    "name": "Angel Beasley",
    "email": "AngelBeasley@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 47,
    "name": "Jalen Clay",
    "email": "JalenClay@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 48,
    "name": "Braelyn Hendricks",
    "email": "BraelynHendricks@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.78
  },
  {
    "id": 49,
    "name": "Alberto Walter",
    "email": "AlbertoWalter@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 50,
    "name": "Jean Edwards",
    "email": "JeanEdwards@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.48
  },
  {
    "id": 51,
    "name": "Devon Willis",
    "email": "DevonWillis@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.38
  },
  {
    "id": 52,
    "name": "Selina Henry",
    "email": "susanbarkley@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.88
  },
  {
    "id": 53,
    "name": "Adrien Harper",
    "email": "AdrienHarper@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.98
  },
  {
    "id": 54,
    "name": "Ryleigh Gardner",
    "email": "RyleighGardner@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 1.98
  },
  {
    "id": 55,
    "name": "Kristen Shaffer",
    "email": "KristenShaffer@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.28
  },
  {
    "id": 56,
    "name": "Lucie Ahmad",
    "email": "susanbarkley@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 57,
    "name": "Orion Golden",
    "email": "OrionGolden@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.48
  },
  {
    "id": 58,
    "name": "Ruth Swanson",
    "email": "RuthSwanson@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.28
  },
  {
    "id": 59,
    "name": "Connor Reilly",
    "email": "ConnorReilly@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.78
  },
  {
    "id": 60,
    "name": "Duncan Ritter",
    "email": "DuncanRitter@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 61,
    "name": "Bridget Haney",
    "email": "BridgetHaney@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.28
  },
  {
    "id": 62,
    "name": "Irene Fischer",
    "email": "IreneFischer@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.88
  },
  {
    "id": 63,
    "name": "Bethany Richardson",
    "email": "BethanyRichardson@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 64,
    "name": "Hayley Hahn",
    "email": "susanbarkley@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.98
  },
  {
    "id": 65,
    "name": "Trinity Hatfield",
    "email": "TrinityHatfield@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.78
  },
  {
    "id": 66,
    "name": "Elias Aguirre",
    "email": "EliasAguirre@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 67,
    "name": "Cory Owens",
    "email": "CoryOwens@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 68,
    "name": "Mylee Barker",
    "email": "MyleeBarker@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 69,
    "name": "Teresa Parker",
    "email": "TeresaParker@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.98
  },
  {
    "id": 70,
    "name": "Larry Atkinson",
    "email": "LarryAtkinson@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.68
  },
  {
    "id": 71,
    "name": "Sammy Short",
    "email": "SammyShort@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.78
  },
  {
    "id": 72,
    "name": "Sheldon Allen",
    "email": "SheldonAllen@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.98
  },
  {
    "id": 73,
    "name": "Lucie Ahmad",
    "email": "susanbarkley@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 2.38
  },
  {
    "id": 74,
    "name": "Akin Mason Hogans",
    "email": "admasonhogans@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.38
  },
  {
    "id": 75,
    "name": "Niara Patterson",
    "email": "anspatterson@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.58
  },
  {
    "id": 76,
    "name": "Dimitri Law",
    "email": "dalaw@aggies.ncat.edu",
    "courses": [
      "Comp365",
      "comp267",
      "Comp476",
      "Math351",
      "Comp476"
    ],
    "taken": [
      "COMP301",
      "BUED279",
      "ECON200",
      "ECON201",
      "FCS135",
      "FCS181",
      "FCS260",
      "HIST103",
      "HIST104",
      "HIST105",
      "HIST106",
      "HIST107",
      "HIST130",
      "HIST206",
      "COMP320",
      "COMP321",
      "COMP323",
      "COMP340",
      "COMP356",
      "COMP361",
      "COMP363",
      "COMP367",
      "COMP368",
      "COMP370",
      "COMP397",
      "COMP398",
      "COMP411",
      "COMP421",
      "COMP422",
      "COMP423"
    ],
    "gpa": 3.66
  },
]
